import classNames from "classnames"
import type { ReactNode } from "react"

interface Props {
  children: ReactNode
  className?: string
}

const MetadataRow = ({ children, className }: Props) => {
  return (
    <div className={classNames("flex flex-wrap gap-2", className)}>
      {children}
    </div>
  )
}

MetadataRow.displayName = "MetadataRow"

export { MetadataRow, type Props }
export default MetadataRow
